export default __webpack_public_path__ + "static/media/hubone.78b4e376.png";